import React, { useState } from "react";
import LeftCircle from "../../assets/Icons/Left circle B.png";
import RightCircle from "../../assets/Icons/Right circle A.png";
import CrossIcon from "../../assets/Icons/cross_svg.svg";
import DeleteIcon from "../../assets/Images/confirm delete.png";
import { Loader } from "lucide-react";

const GlobalDeleteConfirmationModal = ({
  show,
  handleClose,
  onConfirm,
  title = "Confirm Deletion",
  message = "This information will be permanently deleted and cannot be recovered.",
}) => {
  const [loading, setLoading] = useState(false);

  if (!show) return null;

  const handleDelete = async () => {
    try {
      setLoading(true);

      await onConfirm();

      setLoading(false);
      handleClose();
    } catch (error) {
      console.error("Delete error:", error);
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        backgroundColor: "rgba(0,0,0,0.4)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1031,
      }}
    >
      <div className="bg-white w-[480px] rounded-[20px] p-6 shadow-lg relative border border-gray-200">

        {/* Decorative Circles */}

        <img
          src={LeftCircle}
          alt="leftImg"
          className="absolute left-0 bottom-0 w-[110px] h-[105px] z-0"
        />

        <img
          src={RightCircle}
          alt="rightImg"
          className="absolute right-0 top-0 w-[110px] h-[105px] z-0"
        />

        {/* Header */}

        <div
          className="flex justify-between items-center mb-3 relative z-10 pb-3"
          style={{
            borderBottom: "1px solid #dee2e6",
          }}
        >
          <h2 className="text-lg font-semibold text-[#FF6600]">
            {title}
          </h2>

          <img
            src={CrossIcon}
            alt="Close"
            onClick={handleClose}
            className="w-5 h-5 cursor-pointer hover:rotate-90 transition-transform"
          />
        </div>

        {/* Body */}

        <div className="text-center mt-4 relative z-10">

          <img
            src={DeleteIcon}
            alt="Delete"
            className="mx-auto mb-4 w-[160px]"
          />

          <p className="text-gray-700 text-sm">
            {message}
          </p>

        </div>

        {/* Footer */}

        <div className="flex justify-center gap-4 mt-6 relative z-10">

          <button
            onClick={handleClose}
            className="btn btn-back !rounded-[8px] w-[133px]"
          >
            Cancel
          </button>

          <button
            onClick={handleDelete}
            className="btn btn-submit !rounded-[8px] w-[133px] flex justify-center items-center"
            disabled={loading}
          >
            {loading ? (
              <Loader
                className="animate-spin text-[#FF6600]"
                size={22}
              />
            ) : (
              "Delete"
            )}
          </button>

        </div>

      </div>
    </div>
  );
};

export default GlobalDeleteConfirmationModal;